export const SOURCES = [
  { name: 'K Charles', slug: 'kcharles' },
  { name: 'Cargoking', slug: 'cargoking' },
] as const

export const LEGACY_SOURCES = [{ name: 'Cargoking Shipper', slug: 'cargoking-shipper' }] as const

export const ALL_SOURCES = [...SOURCES, ...LEGACY_SOURCES]

export const getSourceLabel = (slug: null | string | undefined): string => {
  if (!slug) return 'N/A'
  return ALL_SOURCES.find(s => s.slug === slug)?.name ?? slug
}
